import { useEffect, useState } from "react";
import { Grid, TextField, MenuItem, Typography } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

export default function BelegOr() {
  const { control, getValues } = useFormContext();

  const intervalle = ["täglich", "wöchentlich", "monatlich", "halbjährlich", "jährlich"];

  const [ablageortGescannteBelege, setAblageortGescannteBelege] = useState("");
  const [zielDateiformatOrg, setZielDateiformatOrg] = useState("");
  const [backUpOrgPapier, setBackUpOrgPapier] = useState("");
  const [vernichtungsintervallPapierhaft, setVernichtungsintervallPapierhaft] = useState("");

  useEffect(() => {
    const initial = getValues("gescanntAblageort");
    if (initial) setAblageortGescannteBelege(initial);
  }, [getValues]);

  useEffect(() => {
    const initial = getValues("zielDateiformatOrg");
    if (initial) setZielDateiformatOrg(initial);
  }, [getValues]);

  useEffect(() => {
    const initial = getValues("backUpOrgPapier");
    if (initial) setBackUpOrgPapier(initial);
  }, [getValues]);

  useEffect(() => {
    const initial = getValues("vernichtungsintervallpapHafteBelegeDigigitalisiert");
    if (initial) setVernichtungsintervallPapierhaft(initial);
  }, [getValues]);

  return (
    <Grid container spacing={3} direction="column">
                 <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
                 Digitalisierung und Aufbewahrung papierhafter Belege                 </Typography>

      <Typography variant="h6" gutterBottom>
        Belege, die originär in Papierform vorliegen bzw. empfangen werden und digitalisiert werden
      </Typography>

      {/* Ablageort */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Digitalisierungsvorgang – Speicherort für originär in Papierform vorliegende Belege. Geben Sie hier an, auf welchem Pfad die Belege gespeichert werden.
        </Typography>
        <Controller
          name="gescanntAblageort"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="C://user/digitaleBelege/..."
              fullWidth
              value={ablageortGescannteBelege}
              onChange={(e) => {
                field.onChange(e);
                setAblageortGescannteBelege(e.target.value);
              }}
            />
          )}
        />
      </Grid>

      {/* Ziel-Dateiformat */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Geben Sie hier das Ziel-Dateiformat der digitalisierten Belege an.
        </Typography>
        <Controller
          name="zielDateiformatOrg"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="PDF/TIFF, etc."
              multiline
              rows={3}
              fullWidth
              value={zielDateiformatOrg}
              onChange={(e) => {
                field.onChange(e);
                setZielDateiformatOrg(e.target.value);
              }}
            />
          )}
        />
      </Grid>

      {/* Backupverfahren / Redundanz */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Beschreiben Sie hier, welche Maßnahmen getroffen werden, um Verluste zu vermeiden (Backupverfahren).
        </Typography>
        <Controller
          name="backUpOrgPapier"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Die Belegdaten werden auf einem gespiegelten NAS-System (RAID-1) gespeichert und per Echtzeit-Synchronisation in ein zweites Rechenzentrum übertragen."
              multiline
              rows={3}
              fullWidth
              value={backUpOrgPapier}
              onChange={(e) => {
                field.onChange(e);
                setBackUpOrgPapier(e.target.value);
              }}
            />
          )}
        />
      </Grid>

      {/* Vernichtungsintervall */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Vernichtungsintervall der papierhaften Belege, welche digitalisiert wurden.
        </Typography>
        <Controller
          name="vernichtungsintervallpapHafteBelegeDigigitalisiert"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Vernichtungsintervall der papierhaften Belege"
              select
              fullWidth
              value={vernichtungsintervallPapierhaft}
              onChange={(e) => {
                field.onChange(e);
                setVernichtungsintervallPapierhaft(e.target.value);
              }}
            >
              {intervalle.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>
    </Grid>
  );
}
